import { useCallback } from 'react';
import { formatTime } from '@elfsight/widget-ui';
import { useBusinessHoursProps } from '../../business-hours-props-context';

export const useTimeFormatter = () => {
  const { language } = useBusinessHoursProps();

  return useCallback(
    (date: Date) => {
      return formatTime({
        date: date,
        locale: language?.language
      });
    },
    [language?.language]
  );
};
